import { Analytics } from './analytics';
import { AddOnSearchReloadOperation } from '../search';

function initTracking() {

    const items = [];

    $("[data-ecommerce-product-model]").each((i, e) => {
        const itemId = e.dataset["ecommerceProductId"];
        const itemName = e.dataset["ecommerceProductName"];
        const affiliation = e.dataset["ecommerceProductAffiliation"];
        const currency = e.dataset["ecommerceProductCurrency"];
        const discount = e.dataset["ecommerceProductDiscount"];
        const index = e.dataset["ecommerceProductIndex"];
        const itemBrand = e.dataset["ecommerceProductItemBrand"];
        const itemCategory = e.dataset["ecommerceProductItemCategory"];
        const itemCategory2 = e.dataset["ecommerceProductItemCategory2"]
        const itemCategory3 = e.dataset["ecommerceProductItemCategory3"];
        const itemListId = e.dataset["ecommerceProductItemListId"];
        const itemListName = e.dataset["ecommerceProductItemListName"];
        const itemVariant = e.dataset["ecommerceProductItemVariant"];
        const price = e.dataset["ecommerceProductPrice"];
        const quantity = e.dataset["ecommerceProductQuantity"];

        const item = {
            "item_id": itemId,
            "item_name": itemName,
            "affiliation": affiliation,
            "currency": currency,
            "discount": discount,
            "index": index,
            "item_brand": itemBrand,
            "item_category": itemCategory,
            "item_category2": itemCategory2,
            "item_category3": itemCategory3,
            "item_list_id": itemListId,
            "item_list_name": itemListName,
            "item_variant": itemVariant,
            "price": price,
            "quantity": quantity
        };

        Object.keys(item).forEach(key => item[key] === undefined ? delete item[key] : {});

        items.push(item);

        $(e).on("click", () => {
            Analytics.sendRawEvent({
                "event": "select_item",
                "ecommerce": {
                    "items": [
                        item
                    ]
                }
            });
        });
    });

    if(items.length) {
        Analytics.sendRawEvent({
            "event": "view_item_list",
            "ecommerce": {
                "items": items
            }
        });
    }
}

initTracking();
AddOnSearchReloadOperation(initTracking);